import api from './api';

const RolePermissionAPI = {
    getAllPermissions: () => {
        const url = '/admin/rolepermission/permissions';
        return api.get(url);
    },
    getRoles: () => {
        const url = '/admin/rolepermission/roles';
        return api.get(url);
    },
    createRole: (data) => {
        const url = '/admin/rolepermission/roles';
        return api.post(url, data);
    },
    getRolePermissions: (roleId) => {
        const url = `/admin/rolepermission/roles/${roleId}/permissions`;
        return api.get(url);
    },
    updateRolePermissions: (roleId, data) => {
        const url = `/admin/rolepermission/roles/${roleId}/permissions`;
        return api.post(url, data);
    },
    getUsersInRole: (roleId) => {
        const url = `/admin/rolepermission/roles/${roleId}/users`;
        return api.get(url);
    },
    getUserPermissions: (userId) => {
        const url = `/admin/rolepermission/users/${userId}/permissions`;
        return api.get(url);
    },
    updateUserPermissions: (userId, data) => {
        const url = `/admin/rolepermission/users/${userId}/permissions`;
        return api.post(url, data);
    },
    createPermissionRequestsBulk: (data) => {
        const url = `/admin/permission-requests/bulk`;
        return api.post(url, data);
    }
};

export default RolePermissionAPI;

